import { Button, ButtonProps } from '@vkontakte/vkui';

interface MessageBubbleAttachButtonProps extends Omit<ButtonProps, 'size' | 'stretched' | 'appearance' | 'mode'> {}

export function MessageBubbleAttachButton(props: MessageBubbleAttachButtonProps) {
  return <Button {...props} size="m" stretched appearance="overlay" mode="primary" />;
}
